export enum TestIDs {
  CHOOSE_PHOTO = 'choose-photo',
  APPLY_ALL = 'apply-all',
  UPSELLING = 'upselling',
  LABEL = 'label',
  TITLE = 'title',
  FILTER = 'filter',
  FILTER_TITLE = 'filter-title',
  EMPTY_IMAGES = 'empty-images',
  ERROR_CART = 'error-cart',
  ERROR_OFFLINE = 'error-offline',
  EXIT_PROJECT = 'exit-project',
  MULTIPLE_PURCHASES = 'multiple-purchases',
  PRIVACY_POLICY = 'privacy-policy',
  QUALITY_ALERT = 'quality-alert',
  SAVE_CHANGES = 'save-changes',
  SAVE_PROJECT_TITLE = 'save-project-title',
  SAVE = 'save',
  SAVED = 'saved',
  SAVE_AND_CLOSE = 'save-and-close',
  REVIEW_LATER = 'review-later',
  SAVE_PROJECT = 'save-project',
  TOOLTIP_DISCOUNT = 'tooltip-discount',
  TOOLTIP_SAVE_PROJECT = 'tooltip-save-project',
  UPLOAD_TO_CART = 'upload-to-cart',
  N8N_CHAT_BUTTON = 'n8nChatButton',
  BOTTOM_BAR_EDIT = 'bottom-bar-edit',
  CLOSE = 'close',
  CONFIRM = 'confirm',
  DISCARD = 'discard',
  DELETE = 'delete',
  ABORT = 'abort',
  CANCEL = 'cancel',
  EXIT = 'exit',
  RESTORE = 'restore',
  UNDO = 'undo',
  REDO = 'redo',
  FRAME = 'frame',
  ORIENTATION = 'orientation',
  CHOOSE = 'choose',
  CHOOSE_GOOGLE_PHOTO = 'choose-google-photo',
  ADJUSTMENTS = 'adjustments',
  REPLACE = 'replace',
  FILE_INPUT = 'file-input',
  BRIGHTNESS_SLIDER = 'brightness-slider',
  SATURATION_SLIDER = 'saturation-slider',
  CONTRAST_SLIDER = 'contrast-slider',
  CHOOSE_PHOTOS_BANNER = 'choose-photos-banner',
  HEADER = 'header',
  LOADER = 'loader',
  PHOTOSI_LOGO = 'photosi-logo',
  PRIVACY_POLICY_CTA = 'privacy-policy-cta',
  PREVIEW_BAR = 'preview-bar',
  SCAFFOLD = 'scaffold',
  SCAFFOLD_CONTENT = 'scaffold-content',
  HEADER_EDITOR = 'header-editor',
  HEADER_EDITOR_CONTAINER = 'header-editor-container',
  HEADER_ADD_PRODUCT_CTA = 'header-add-product-cta',
  FOOTER_EDITOR = 'footer-editor',
  BOTTOM_BAR = 'bottom-bar',
  NUMBER_OF_PRODUCT = 'number-of-product',
  PRICE_ESTIMATE = 'price-estimate',
  PRICE_ORIGINAL = 'price-original',
  ADD_PRODUCT = 'add-product',
  ADD_TO_CART = 'add-to-cart',
  PRODUCT_LIST = 'product-list',
  ADD_FRAME_BUTTON = 'add-frame-button',
  SWITCH_TO_SET_BUTTON = 'switch-to-set-button',
  ANIMATED_ELEMENT_VIEW = 'animated-element-view',
  TOTAL_PRODUCTS = 'total-products',
  PICTURE_VIER_HEADER = 'picture-vier-header',
  TOAST_WRAPPER = 'toast-wrapper',
  SLIDER_ZOOM = 'slider-zoom',
  ZOOM_OUT_BUTTON = 'zoom-out-button',
  ZOOM_SLIDER = 'zoom-slider',
  BAR = 'bar',
  ZOOM_IN_BUTTON = 'zoom-in-button',
  ROOT_GESTURE_HANDLER = 'root-gesture-handler',
  PRODUCT = 'product',
  UPDATING_LAYER = 'updating-layer',
  CHAT_BUTTON = 'chat-button',
  LEFT_ARROW = 'left-arrow',
  RIGHT_ARROW = 'right-arrow',
  PRODUCTS_COUNTER = 'products-counter',
  BACK = 'back',
  TOAST_NOTIFICATION = 'toast-notification',
  CONFIGURATION = 'configuration',
  CONFIGURATION_OTHER_OPTIONS = 'configuration-other-options',
  LOOKUPS_BAR = 'lookups-bar',
  OTHER_OPTIONS = 'other-options',
  DELETE_FRAME = 'delete-frame',
  SUBOPTIMAL_QUALITY_ALERT = 'suboptimal-quality-alert',
  FULL_PRICE = 'full-price',
  PRICE = 'price',
  SLIDER_ROTATION = 'slider-rotation',
  ROTATE_NEXT = 'rotate-next',
  ROTATE_PREV = 'rotate-prev',
  ANGLE = 'angle',
  EDIT = 'edit',
  APP_VERSION = 'app-version',
  NEW_VERSION_AVAILABLE = 'new-version-available',
  PRODUCT_NOT_AVAILABLE = 'product-not-available',
  FULLSCREEN = 'fullscreen',
  CANVAS = 'canvas',
  LEGER = 'leger',
  PHOTO_CLASSIC = 'photo-classic',
  CONFIGURATION_STEPS = 'configuration-steps',
  FIX = 'fix',
  IGNORE = 'ignore',
  CUT_ALERT = 'cut-alert',
  CUT_CONFIRMATION_ALERT = 'cut-confirmation-alert',
  REVIEW = 'review',
  CONTINUE = 'continue',
  GOOGLE_PHOTO_LOGIN = 'google-photo-login',
  PICKER_SOURCE = 'picker-source',
  PRESS = 'press',
  SELECTION = 'selection',
  LOOKUP_CHOICE = 'lookup-choice',
  ADD_TO_PROJECT = 'add-to-project',
  UPLOAD_PHOTO = 'upload-photo',
  PHOTO_VINTAGE = 'photo-vintage',
  REARRANGE = 'rearrange',
  SLIDER_DOT = 'slider-dot',
  CTA = 'cta',
  SELECT_PHOTO = 'select-photo',
  SELECT_ALL = 'select-all',
  DESELECT_ALL = 'deselect-all',
  EDIT_PRODUCTS = 'edit-products',
  EDIT_PROJECT_TITLE = 'edit-project-title',
  INFO = 'info',
  ADJUST_CROPS = 'adjust-crops',
  HELP_BUTTON = 'help-button',
  PHOTO_DRAWER = 'photo-drawer',
  PHOTO_DRAWER_ORDER = 'photo-drawer-order',
  DUPLICATE = 'duplicate',
  DUPLICATE_SELECTED = 'duplicate-selected',
  OPEN = 'open',
  FILTER_GROUP = 'filter-group',
  SELECTED_PRODUCTS = 'selected-products',
  DELETE_SELECTED = 'delete-selected',
  ADD_OPTIONS_POPUP = 'add-options-popup',
  SELECT_BOX_STYLE = 'select-box-style',
  OVER_LIMIT_PRODUCTS = 'over-limit-products',
  ADD = 'add',
  REMOVE = 'remove',
  MIN_PRODUCTS_ALERT = 'min-products-alert',
  MAX_PRODUCTS_ALERT = 'max-products-alert',
  BELOW_LIMIT_PRODUCTS = 'below-limit-products',
  UPLOAD_ERROR = 'upload-error',
  RETRY = 'retry',
  NETWORK = 'network',
  GROUP_TAB = 'group-tab',
  ADD_GROUP_TAB = 'add-group-tab',
  ADD_MORE_PHOTOS = 'add-more-photos',
  CONTENT_HEADER = 'content-header',
  CONTENT_FOOTER = 'content-footer',
  CHECKBOX = 'checkbox',
  PAPER = 'paper',
  OPTIONS_MENU = 'options-menu',
  SUBTRACT = 'subtract',
  INCREASE = 'increase',
  PRODUCT_COUNT = 'product-count',
  DISCOVER_DISCOUNT = 'discover-discount',
  DISCOUNT_SCALE_INFO_DROPUP = 'discount-scale-info-dropup',
  TEXT = 'text',
  TEXT_FONT = 'text-font',
  TEXT_STYLE = 'text-style',
  TEXT_SIZE = 'text-size',
  TEXT_ALIGNMENT = 'text-alignment',
  TEXT_COLOR = 'text-color',
  TEXT_SAVE_BUTTON = 'text-save-button',
  IMAGE_WRAPPER = 'image-wrapper',
  COLOR_WRAPPER = 'color-wrapper',
  DESCRIPTION = 'description',
  DROPDOWN_OPTION = 'dropdown-option',
  ALIGNMENT_OPTION = 'alignment-option',
  SELECTED = 'selected',
  PROJECT_TITLE_INPUT = 'project-title-input',
  NO_AVAILABLE_SPACE = 'no-available-space',
}
